import React from "react";

import {
    Grid,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Typography
} from "@mui/material";

import StarIcon from '@mui/icons-material/Star';

// const useStyles = (theme) => ({
//     card: {
//         height: '78vh',
//         overflow: "auto",
//         padding: theme.spacing(1),
//         textAlign: 'center',
//         backgroundColor: theme.palette.secondary.main,
//     },
//     paper: {
//         marginTop: theme.spacing(1),
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         backgroundColor: "white",
//         paddingLeft: theme.spacing(2),
//         paddingRight: theme.spacing(2),
//     },
//     margin: {
//         margin: theme.spacing(1),
//     },
// })

export default function Intro(props) {
    // const classes = useStyles();

    function BulletList(props) {
        const disabled = props.disabled ? true : false;
        return (
            <ListItem button disabled={disabled}>
                <ListItemIcon>
                    <StarIcon style={{ fontSize: "20" }} />
                </ListItemIcon>
                <ListItemText primary={props.primary} />
            </ListItem>
        )
    }

    return (
        <div style={{ padding: "10px" }}>
            <Grid container direction="row">
                <Grid container >
                    <Grid>
                        <Typography variant="h4">Athenos bevoorschottingscalculator</Typography>
                        <br />
                        <br />
                        <Typography variant="h6">De bevoorschottingscalculator berekent op eenvoudige wijze het Verlies Arbeidsvermogen van een zelfstandig ondernemer die slachtoffer is bij een Personenschade.</Typography>
                        <br />
                        <br />
                        <Typography variant="h6">Om de berekening te kunnen maken, is het volgende vereist:</Typography>
                        <List dense>
                            <BulletList primary="De zaak betreft een zelfstandig ondernemer met een eenmanszaak en een relatief stabiele bedrijfsvoering" />
                            <BulletList primary="Aangiftes inkomstenbelasting van 2 of 3 jaar voorafgaande aan het ongeval" />
                            <BulletList primary="De saldibalansen van de aangiftes omzetbelasting van het jaar van het ongeval" />
                            <BulletList primary="Een inschatting door de ondernemer van het verloop van de exploitatie na het ongeval" />
                        </List>
                        <br />
                    </Grid>
                    <Grid>
                        <br />
                        <Typography variant="h6">De berekening is dus niet te maken voor startende ondernemers, of ondernemers met een VOF, BV of andere rechtsvorm.</Typography>
                        <br />
                        <Typography variant="h6">Athenos adviesgroep is niet aansprakelijk voor fouten als gevolg van het gebruik van de Bevoorschottingscalculator.</Typography>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}
